import { render, staticRenderFns } from "./AnswerImages.vue?vue&type=template&id=4127ccb2"
import script from "./AnswerImages.vue?vue&type=script&lang=js"
export * from "./AnswerImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports